<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" v-bind="attrs" v-on="on">
                <v-icon>add_circle</v-icon>Add
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="onRegister">
                <v-list-tile-content>
                  <v-list-tile-title>ADD NEW</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="printAllButtonLoading"
                v-bind="attrs"
                v-on="on"
                ><v-icon>cloud_download</v-icon>Export</v-btn
              >
            </template>

            <v-list>
              <v-list-tile @click="printAll('printAllAccountPayableList')">
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="exportAllAccountPayable()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="supplierName"
                label="Supplier Name"
                type="text"
                v-model="queryParams.supplierName"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="issueNo"
                label="Issue No"
                type="text"
                v-model="queryParams.issueNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-select
                :items="accountPayableStatusList"
                label="Choose Status..."
                :hide-no-data="true"
                color="blue-grey lighten-2"
                item-text="label"
                item-value="value"
                menu-props="auto"
                v-model="queryParams.status"
              ></v-select>
            </v-flex>
            <v-flex sm4>
              <v-select
                :items="shopList"
                label="Select Shop"
                item-text="name"
                item-value="value"
                v-model="queryParams.shopName"
                :disabled="checkUserShop() ? true : false"
              ></v-select>
            </v-flex>
            <v-flex sm4>
              <v-select
                :items="apTypeList"
                label="Select Type"
                item-text="label"
                item-value="value"
                v-model="queryParams.apType"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="chequeNo"
                label="Cheque No"
                type="text"
                v-model="queryParams.chequeNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-title class="blue darken-3">
            <span class="headline white--text">Summary</span>
            <v-spacer></v-spacer>
            <v-icon class="white--text" @click="show = !show">{{
              show ? "keyboard_arrow_up" : "keyboard_arrow_down"
            }}</v-icon>
          </v-card-title>
          <v-card-text class="font-weight-bold" v-show="show">
            <div>
              <span>Total Payable Amount :</span>
              <v-chip>
                <span>{{ totalPayableAmount | decFormat(6) }}</span>
              </v-chip>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :must-sort="true"
            :headers="headers"
            :items="accountPayableList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-btn
                  flat
                  icon
                  color="blue lighten-2"
                  @click="onEdit(props.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
              <td>{{ props.item.accountPayableStatus }}</td>
              <td>
                {{ props.item.issueDateInMilliSeconds | format-ms-date }}
              </td>
              <td>{{ props.item.issueNo }}</td>
              <td>{{ props.item.shop.name }}</td>
              <td>{{ props.item.supplier.companyName }}</td>
              <td>{{ props.item.apType }}</td>
              <td>{{ props.item.operationSettingName }}</td>
              <td style="text-align: right">
                {{ props.item.creditAmount | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ props.item.cashAmount | decFormat(6) }}
              </td>
              <td>{{ props.item.chequeNo }}</td>
              <td>
                <v-btn color="primary" @click.stop="onShowDetail(props.item)"
                  >Detail</v-btn
                >
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- detail dialog -->
    <v-dialog v-model="showdetaildialog" scrollable max-width="1000px">
      <v-card>
        <v-card-text>
          <!-- Customer List Section -->
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :must-sort="true"
                :headers="detailheaders"
                :items="accountPayableDetailList"
                class="elevation-1"
                :loading="showDetailListLoading"
                :total-items="totalDetailRows"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="detailpagination"
              >
                <template slot="items" slot-scope="props">
                  <td>
                    {{
                      props.item.purchaseOrder.issueDateInMilliSeconds
                        | format-ms-date
                    }}
                  </td>
                  <td>{{ props.item.purchaseOrder.issueNo }}</td>
                  <td>{{ supplierName }}</td>
                  <td>{{ currencyCode }}</td>
                  <td style="text-align: right">
                    {{ props.item.payableAmount | decFormat(6) }}
                  </td>
                  <td style="text-align: right">
                    {{ props.item.purchaseOrder.totalUnitCost }}
                  </td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- <accountpayable report> -->
    <div
      id="printAllAccountPayableList"
      style="bsale: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center">
        <p style="font-size: 18px; margin: 1px">Account Payable</p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          From: [{{ queryParams.fromDate }}] To: [{{ queryParams.toDate }}]
        </p>
      </div>
      <div style="text-align: left">
        <p style="font-size: 15px; margin: 1px">
          Total Payable Amount : {{ totalPayableAmount | decFormat(6) }}
        </p>
      </div>
      <br />
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 11px;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr>
              <th style="text-align: left">Issue Date</th>
              <th style="text-align: left">Issue No</th>
              <th style="text-align: left">Shop</th>
              <th style="text-align: left">Supplier</th>
              <th style="text-align: left">Status</th>
              <th style="text-align: left">Credit Amount</th>
              <th style="text-align: left">Cash Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in allaccountPayableList" :key="index">
              <td style="text-align: left">
                {{ item.issueDateInMilliSeconds | format-ms-date }}
              </td>
              <td style="text-align: left">{{ item.issueNo }}</td>
              <td style="text-align: left">{{ item.shop > Name }}</td>
              <td style="text-align: left">{{ item.supplier.companyName }}</td>
              <td style="text-align: left">{{ item.accountPayableStatus }}</td>
              <td style="text-align: left">{{ item.creditAmount }}</td>
              <td style="text-align: left">{{ item.cashAmount }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </v-container>
</template>
<script>
import { accountPayableService } from "../../services/account-payable-service";
import { accountPayableDetailService } from "../../services/account-payable-detail-service";
import { commonService } from "../../services/common-service";
import { shopService } from "../../services/shop-service";

export default {
  name: "AccountPayableList",
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showFilters: false,
    show: false,
    breadcrumbs: [
      {
        text: "Finance",
        disabled: true,
      },
      {
        text: "Account Payable",
        disabled: true,
      },
    ],
    headers: [
      { text: "Action", sortable: false },
      { text: "Status", value: "accountReceiveStatus", sortable: false },
      {
        text: "Issue Date",
        align: "left",
        value: "warehouse.name",
        sortable: false,
      },
      { text: "Issue No", align: "left", value: "issueNo", sortable: false },
      { text: "Shop", align: "left", value: "shop", sortable: false },
      { text: "Supplier Name", value: "supplier", sortable: false },
      { text: "Type", value: "apType", sortable: false },
      { text: "Operation Setting Name", value: "operationSettingName", sortable: false },
      { text: "Credit Amount", value: "creditAmount", sortable: false },
      { text: "Cash Amount", value: "cashAmount", sortable: false },
      { text: "Cheque No", value: "chequeNo", sortable: false },
      { text: "Detail", align: "center", sortable: false },
    ],
    detailheaders: [
      {
        text: "Issue Date",
        align: "left",
        sortable: false,
      },
      { text: "PO No", align: "left", sortable: false },
      { text: "Supplier Name", value: "supplier", sortable: false },
      { text: "Currency", sortable: false },
      { text: "Paid Amount", sortable: false },
      { text: "Total Unit Cost", sortable: false },
    ],
    accountPayableStatusList: [
      { label: "----All----", value: "" },
      { label: "DRAFT", value: "DRAFT" },
      { label: "CONFIRM", value: "CONFIRM" },
      { label: "CANCEL", value: "CANCEL" },
    ],
    apTypeList: [
      { label: "----All----", value: "" },
      { label: "Purchase Payment", value: "PURCHASE_PAYMENT" },
      { label: "Advance Purchase Payment", value: "ADVANCE_PURCHASE_PAYMENT" },
      { label: "Discount", value: "DISCOUNT" },
      { label: "Supplier Advanced", value: "SUPPLIER_ADVANCED" },
      { label: "Advance Repayment", value: "ADVANCE_REPAYMENT" },
    ],
    shopList: [],
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      supplierName: "",
      status: "",
      issueNo: "",
      shopName: "",
      apType: "",
      chequeNo: "",
    },
    detailqueryParams: {
      accountPayableId: "",
    },
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "createdDate",
      totalItems: 0,
    },
    totalPayableAmount: 0,
    totalAmount: 0,
    totalRows: 0,
    showListLoading: false,

    detailpagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "created_date",
      totalItems: 0,
    },
    totalDetailRows: 0,
    showDetailListLoading: false,
    buttonLoading: false,
    printAllButtonLoading: false,
    accountPayableList: [],
    decimalFormat: "",
    allaccountPayableList: [],
    accountPayableDetailList: [],
    showdetaildialog: false,
    supplierName: "",
    currencyCode: "",
  }),
  watch: {
    pagination: {
      handler() {
        this.getAccountPayableList();
      },
      deep: true,
    },
    detailpagination: {
      handler() {
        this.getAccountPayableDetailList();
      },
      deep: true,
    },
  },
  created() {
    this.queryParams.shopName = this.checkUserShop();

    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.issueNo) {
      this.queryParams.issueNo = this.$route.query.issueNo;
    }
    if (this.$route.query.supplierName) {
      this.queryParams.supplierName = this.$route.query.supplierName;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.apType) {
      this.queryParams.apType = this.$route.query.apType;
    }
    if (this.$route.query.shopName) {
      this.queryParams.shopName = this.$route.query.shopName;
    }
    if (this.$route.query.chequeNo) {
      this.queryParams.chequeNo = this.$route.query.chequeNo;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.getShopList();
    this.decimalFormat = commonService.formatdecimal();
  },

  methods: {
    checkUserShop() {
      if (this.user.role.roleName == "BRANCH_ADMIN") {
        return this.user.shop.name;
      } else {
        return "";
      }
    },
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "accountpayables",
        query: this.queryParams,
      });
      this.getAccountPayableList();
    },
    getShopList() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getAccountPayableList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      accountPayableService
        .getAccountPayableList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.accountPayableList = res.data.accountPayableList;
            this.totalRows = res.data.totalElements;
            this.totalPayableAmount = res.data.totalCashAmount;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    printAll(divName) {
      this.printAllButtonLoading = true;
      accountPayableService
        .getAllAccountPayableList(this.queryParams)
        .then((res) => {
          if (res.data) {
            this.allaccountPayableList = res.data.accountPayableList;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.printAllButtonLoading = false;
        });
    },
    exportAllAccountPayable() {
      this.printAllButtonLoading = true;
      accountPayableService
        .exportAllAccountPayableDetailExcel(this.queryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .finally(() => {
          this.printAllButtonLoading = false;
        });
    },
    onShowDetail(ac) {
      this.detailqueryParams.accountPayableId = ac.id;
      this.supplierName = ac.supplier.companyName;
      this.currencyCode = ac.currencyCode;
      this.getAccountPayableDetailList();
      this.showdetaildialog = !this.showdetaildialog;
    },
    getAccountPayableDetailList() {
      this.showDetailListLoading = true;
      let order = this.detailpagination.descending ? "desc" : "asc";
      accountPayableDetailService
        .getAccountPayableDetailList(
          this.detailqueryParams,
          this.detailpagination.page,
          this.detailpagination.rowsPerPage,
          this.detailpagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.accountPayableDetailList = res.data.accountPayableDetailList;
            this.totalDetailRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showDetailListLoading = false;
        });
    },
    onRegister() {
      this.$router.push("/accountpayable/new");
    },
    onEdit(accountpayable) {
      // go to details page
      this.$router.push("/accountpayable/" + accountpayable.id);
    },
  },
};
</script>